import React from "react";
import SupplyCompactTable from "container/supplyAccuracyEffectiveness/SupplyCompactTable";
import Accordion from 'component/utils/Accordion'
import propTypes from 'prop-types'

const AccordionTableTitleStores = ({
  branch,

  positionQty,
  positionCountedQty,
  positionNotCountedQty,
  accuracity,
  effectiveness,
  notCountedPercentage,
}) => (
  <table key={branch} className='table-compact text-uppercase'>
    <tbody>
      <tr />
      <tr>
        <td width='15%'>{branch}</td>
        <td width='14%' className='align-center'>
          {positionQty}
        </td>
        <td width='14%' className='align-center'>
          {positionCountedQty}
        </td>
        <td style={{color: positionNotCountedQty > 0 && "#B42A27"}} width='14%' className='align-center'>
          {positionNotCountedQty}
        </td>
        <td style={{paddingLeft: "1.5rem"}}  width='10%' className='align-center'>
          {accuracity}%
        </td>
        <td style={{paddingLeft: "1.5rem", color: effectiveness === 0 && "#B42A27"}}  width='10%' className='align-center'>
          {effectiveness}%
        </td>

        <td  style={{textAlign:"center", color: notCountedPercentage > 0 && "#B42A27"}} width='23%' >
          {notCountedPercentage}%
        </td>
      </tr>
    </tbody>
  </table>
)

AccordionTableTitleStores.propTypes = {
  branch: propTypes.string,
  positionQty: propTypes.string,
  positionCountedQty: propTypes.string,
  positionNotCountedQty: propTypes.string,
  accuracity: propTypes.string,
  effectiveness: propTypes.string,
  notCountedPercentage: propTypes.string
}

function compactTableSupplyInfo(details)  {
  return {
    hideHeader: true,
    columns: [
      {
        selector: 'deposit',
        extraDataProps: {
          width: '15%',
        },
      },
      {
        selector: 'positionQty',
        centerData: true,
        extraDataProps: {
          width: '14%',
        },
      },
      {
        selector: 'positionCountedQty',
        centerData: true,
        extraDataProps: {
          width: '14%',
        },
      },
      {
        selector: 'positionNotCountedQty',
        centerData: true,
        extraDataProps: {
          width: '14%',
        },
      },
      {
        selector: 'accuracity',
        parsingFn: (v) => `${v}%`,
        centerData: true,
        extraDataProps: {
          width: '10%',
        },
      },
      {
        selector: 'effectiveness',
        centerData: true,
        centerTitle: true,
        parsingFn: (v) => `${v}%`,
        extraDataProps: {
          width: '10%',
        },

        
      },

      {
        selector: 'notCountedPercentage',
        parsingFn: (v) => `${v}%`,
        centerData: true,
        extraDataProps: {
          width: '23%',
        },

        
      },

    ],
    data:  details ?? []
  }
}

const SupplyDataBox = ({name, info, index}) => (
    <>
        <table className='full-w text-center header-table'>
            <thead>
            <tr>
                <td className='text-left' width='15%'>{name}</td>
                <td className='text-center'  width='14%'>
                Qtde. posições listadas
                </td>
                <td className='text-center' width='14%'>
                Qtde posições contadas
                </td>
                <td className='text-center' width='14%'>
                Qtde posições não contadas
                </td>
                <td className='text-center' width='10%'>
                Acuracidade
                </td>

                <td className='text-center' width='10%' >
                Efetividade
                </td>

                <td style={{paddingLeft:"0px"}} className='text-center' width='23%' >
                Não contada %
                </td>
            </tr>
            </thead>
        </table>

        <div className={`supply-data-container ${index === 0 ? "supply-first-spacer" : ''}`}>
        {info.map((data, index) => (
                    
                  
                  <Accordion
                      className='margin-top no-margin-bottom accordion-box'
                      isNewComponent={true}
                      key={`$accordion-${data.title}-${index}`}
                      size='sm'
                      title={
                      <AccordionTableTitleStores
                        branch={data.title ?? ""}
                        positionQty={ data.positionQty ?? ""}
                        positionCountedQty={data.positionCountedQty ?? ""}
                        positionNotCountedQty={data.positionNotCountedQty ?? ""}
                        accuracity={data.accuracity ?? ""}
                        effectiveness={data.effectiveness ?? ""}
                        notCountedPercentage={data.notCountedPercentage ?? ""}
                      /> }
                  >

                      <SupplyCompactTable key={`$table-${data.title}-${index}`}
                        {...compactTableSupplyInfo(data.details)}
                      />
                  </Accordion>
                  ))}
        </div>
    </>
    )

SupplyDataBox.propTypes = {
  name: propTypes.string,
  info: propTypes.arrayOf(propTypes.object),
  index: propTypes.number
}

export default SupplyDataBox